import * as React from "react";
import { createEditor, Editor } from "slate";
import { withHistory } from "slate-history";
import { withReact } from "slate-react";
import { Element, Leaf } from "../components";
import * as plugins from "../plugins";
import { ElementProps } from "./types";
import { compose } from "./utils";

interface Options {
  elementTypeProps?: ElementProps["elementTypeProps"];
  editor?: Editor;
}

export const useInitSlate = (options?: Options) => {
  const [editor] = React.useState(() =>
    compose(
      plugins.withEventListeners,
      plugins.withCommonMethods,
      plugins.withLists,
      withReact,
      withHistory
    )(options?.editor || createEditor())
  );

  const renderLeaf = React.useCallback((props: any) => <Leaf {...props} />, []);
  const renderElement = React.useCallback(
    (props: any) => (
      <Element {...props} elementTypeProps={options?.elementTypeProps} />
    ),
    [options?.elementTypeProps]
  );

  return { editor, renderElement, renderLeaf };
};
